import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectSupplierAllocations,
  selectSupplierAllocationsError,
  selectSupplierAllocationsLoading,
} from './manage-survey-reference.selectors';

@Injectable({ providedIn: 'root' })
export class ManageSurveyReferenceSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly supplierAllocations = this._store.selectSignal(
    selectSupplierAllocations,
  );

  public readonly supplierAllocationsLoading = this._store.selectSignal(
    selectSupplierAllocationsLoading,
  );

  public readonly supplierAllocationsError = this._store.selectSignal(
    selectSupplierAllocationsError,
  );
}
